import React from 'react';

import { CompanyLogoBadge } from '../../../../CompanyLogoBadge';
import styles from './CompanyNameCellRenderer.module.scss';

/**
 * Table-cell adapter for the shared CompanyLogoBadge. Resolves the logo
 * from whatever the row provides:
 *  - Leads rows carry `websiteUrl` (and sometimes `logo`) → built directly, no fetch.
 *  - Deals / Mandate rows carry only an org id (`dealBeneficiaryId`) → fetched by id.
 */
export const CellCompanyLogo: React.FC<{ row: any; name?: string }> = ({ row, name }) => {
    return (
        <CompanyLogoBadge
            name={name ?? row?.orgName ?? row?.borrowerName}
            logo={row?.logo}
            websiteUrl={row?.websiteUrl}
            orgId={row?.assesseeOrgId ?? row?.dealBeneficiaryId}
            size={24}
            shape="square"
            className={styles.CellLogoRadius}
        />
    );
};

export default CellCompanyLogo;
